// The English table (ship 3): the same keys, kinds and placeholders as th.js — apps/coffee-cup/test/tables.test.js
// holds the two together. Depths and fit numbers come from doc.js, never typed here.
import { FITS, DEPTH, SNAP, snapOverlap, fmt } from '../doc.js';
const S = {
  title: "Coffee cup with a logo",
  gLogo: "Logo on the cup",
  gSize: "Cup size",
  gColour: "Colours",
  gLid: "Lid and printing",
  loadingFont: (family, got, total) => (total > 0 ? `Loading ${family} ${got.toFixed(1)} / ${total.toFixed(1)} MB` : `Loading ${family} ${got.toFixed(1)} MB`),
  needFile: "Choose the logo’s SVG file — it stays on your device and is sent nowhere",
  artKept: "The logo lives only in this tab — after a refresh you must choose the file again",
  keptOld: "(still using the previous logo)",
  thumb: "Preview of the logo read",
  mode: "Logo style",
  modes: {
    flush: "Flush",
    raised: "Raised",
    engraved: "Engraved",
  },
  styleLabel: "Cup shape",
  styles: {
    classic: "Classic shape",
    thin: "True thin wall",
  },
  modeNote: (style, mode) => {
    if (mode === 'raised') return `Raised ${fmt(DEPTH[style].raised[1])} mm — works on multi-colour and single-colour printers alike (single colour shows it as a relief)`;
    if (mode === 'engraved') return `Engraved ${fmt(DEPTH[style].engraved[0])} mm deep, no separate logo piece — suited to single-colour printers`;
    const flush = 'Flush with the cup surface — for multi-colour printers (single colour will not show the logo)';
    return style === 'thin' ? `${flush} Thin wall: the logo is ${fmt(DEPTH.thin.flush[0])} mm thick; light colours on a dark cup may look dim — choose Raised for solid colour` : flush;
  },
  scale: "Logo size",
  pos: "Move up–down",
  hideThin: "Hide pieces too thin to print",
  signedPercent: (v) => `${v > 0 ? '+' : ''}${Math.round(v * 100)}%`,
  size: "Size",
  presets: {
    mini: "Mini",
    s: "S",
    m: "M",
    l: "L",
  },
  d: "Diameter (mm)",
  adjusted: (v, lo, hi) => `Set to ${v} mm (the workable range is ${lo}–${hi} mm)`,
  looks: "Colour sets",
  lookNames: {
    mono: "Black–white",
    kraft: "Kraft",
    white: "White",
  },
  parts: {
    body: "Cup",
    ring: "Ring",
    logo: "Logo",
  },
  colour: {
    body: "Cup colour",
    lid: "Lid colour",
    ring: "Ring colour",
    logo: "Logo colour",
  },
  lidOn: "Add a lid",
  ringOn: "Ring",
  fit: "Lid fit",
  fits: {
    tight: "Very tight",
    snug: "Snug",
    normal: "A bit loose",
    loose: "Loose",
  },
  fitNote: (style, fit, d) => {
    if (style !== 'thin') return `${fmt(FITS[fit])} mm of clearance per side — the lid rides on friction, with no latch`;
    if (fit === 'loose') return `The lid sits loose, unlatched — ${fmt(SNAP.loose.c)} mm of clearance per side`;
    return `The lid latches under the cup’s rim — the latch overlaps it by ${snapOverlap(SNAP[fit], d).toFixed(2)} mm`;
  },
  partLabel: "Downloaded file",
  partNames: {
    set: "Set",
    cup: "Cup",
    lid: "Lid",
  },
  lift: "Lift the lid",
  outer: (d, h) => `ø ${d} × ${h} mm`,
  footprint: (w, d) => `Prints ${w} × ${d} mm`,
  capacity: (ml) => `Holds ${ml} ml`,
  problem: {
    "thin-text": "The letters are very thin — some strokes may not print; try a larger cup or fewer characters",
    "thin-parts": "The logo has thin strokes attached to thick parts — a slicer may cut them away",
    dropped: (p) => `Dropped ${p.n} pieces too thin to print from the logo`,
    "all-thin": "The logo is too thin for this cup size — no download",
    "art-too-complex": "The logo is too complex — no download",
  },
  hairline: "Limitation: very thin strokes attached to thick parts of the logo cannot be detected, and a slicer may cut them away — check the preview in your slicer before printing",
  dlstl: "STL",
  copied: "Copied",
  fatal: "Could not load the calculator — try refreshing the page",
  buildTimeout: (src) => (src === 'svg' ? 'A build did not finish in 10 seconds and was restarted — try a simpler file' : 'A build did not finish in 10 seconds and was restarted — try fewer characters or another font'),

  // ship 3 piece c: the template's static text, baked per language by the build (was hardcoded Thai)
  aboutP: "Design a miniature coffee cup with a lid — your name or shop logo on the body, your choice of size, colours and how tight the lid sits. Download 3MF/STL files free. It is a decoration, not a drinking vessel.",
};
export default S;
